import { ReactNode } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { Button } from "@/components/catalyst/button";

export type SubmitButtonInputProps = {
  isLoading?: boolean;
  children: ReactNode;
};

export function SubmitButtonInput({
  isLoading,
  children,
}: SubmitButtonInputProps) {
  const { errorCount, isSubmitting, submitCount, isValid } = useFormState();
  const showWarning = submitCount > 1 && !isValid;

  return (
    <div className="col-span-full mt-4">
      <Button
        type="submit"
        isLoading={isLoading || isSubmitting}
        color={showWarning ? "red" : "indigo"}
        className="w-full"
      >
        {showWarning ? <ExclamationTriangleIcon /> : null}
        {showWarning ? `${errorCount} error(s)` : children}
      </Button>
    </div>
  );
}
